import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Icon, Intent, InputGroup } from '@blueprintjs/core';
import Clearfix from 'components/elements/clearfix';
import { IconNames } from '@blueprintjs/icons';
import { createForm } from 'rc-form';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import slug from 'constants/slug';
import IconRequired from 'components/elements/required-icon';
import FacilitySelect from 'components/elements/select-facility';
import { STYLE } from 'config';
import CustomDataSelect from 'components/elements/select-custom-data';
import { COLOR } from 'config';
import NumberInput from 'rc-input-number';
import {
  QuaterOfChargeData,
  SubjectOfChargeData,
  getDataForCustomSelect,
  AuthorityBVMTData,
  PaymentStatusData,
} from 'constants/custom-data';
// import dynamicRoleHOC from 'hoc/dynamicRole';

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
`;

// @dynamicRoleHOC()
class FacilityEnviProtectFeeForm extends React.Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    initialValue: PropTypes.object,
    slugBack: PropTypes.string,
    handelSubmit: PropTypes.func,
    // facility: PropTypes.shape({
    //   _id: PropTypes.string,
    //   FacilityNameFull: PropTypes.string
    // })
  };

  constructor(props) {
    super(props);
    this.state = {};
    this.isPaymentStatus = false;
    if (props.isEdit) {
      this.isPaymentStatus =
        _.result(this.props.initialValue, 'PaymentStatus') === 'Đã nộp'
          ? true
          : false;
    }
  }

  setInitialValue(keyPath, defaultValue) {
    if (this.props.isEdit) {
      let value = _.result(this.props.initialValue, keyPath, defaultValue);
      if (!value) value = defaultValue;
      return value;
    }
    return defaultValue;
  }

  setSelInitialValue(keyPath, defaultValue, nameLabel) {
    if (this.props.isEdit) {
      let selItem = _.result(this.props.initialValue, keyPath);
      if (!selItem) return defaultValue;
      return {
        value: selItem._id,
        label: nameLabel ? selItem[nameLabel] : selItem.Name,
      };
    }
    return defaultValue;
  }

  submit = () => {
    this.props.form.validateFields((error, value) => {
      // console.log(value);
      value.facility = _.get(value.facility, 'value');
      value.QuaterOfCharge = _.get(value.QuaterOfCharge, 'value');
      value.SubjectOfCharge = _.get(value.SubjectOfCharge, 'value');

      value.AuthorityBVMT = _.get(value.AuthorityBVMT, 'value');
      value.PaymentStatus = _.get(value.PaymentStatus, 'value');

      if (!value.AverageWaterDemand) value.AverageWaterDemand = null;
      if (!value.AverageWasteWater) value.AverageWasteWater = null;
      if (!value.AverageWasteWaterEnviProfile)
        value.AverageWasteWaterEnviProfile = null;
      if (!value.AverageWasteWaterActual) value.AverageWasteWaterActual = null;
      if (!value.TotalWasteWaterOfQuarter)
        value.TotalWasteWaterOfQuarter = null;

      if (error) return;
      this.props.handelSubmit(value);
    });
  };

  renderLogic() {
    const { getFieldProps } = this.props.form;
    return [
      <Clearfix key={'Clearfix1'} height={8} />,
      <Row key='Payment_Row'>
        <Col xs={4}>
          <LabelContainer>Số tiền</LabelContainer>
        </Col>
        <Col xs={4}>
          <NumberInput
            placeholder='Số tiền'
            {...getFieldProps('Payment', {
              initialValue: this.setInitialValue('Payment', null),
            })}
          />
        </Col>
      </Row>,
    ];
  }

  render() {
    const { getFieldProps, getFieldError, getFieldValue } = this.props.form;
    const PaymentStatus = getFieldValue('PaymentStatus');
    const isPaymentStatus =
      this.isPaymentStatus || _.result(PaymentStatus, 'label') === 'Đã nộp'
        ? true
        : false;
    return (
      <div>
        <h4
          className='bp3-heading'
          style={{
            color: COLOR.SUCCESS,
          }}
        >
          Phí bảo vệ môi trường
        </h4>
        <Row>
          <Col xs={4}>
            <HeaderContainer>
              <Icon
                icon={IconNames.SAVED}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.PRIMARY}
                onClick={() => {
                  this.submit();
                }}
                style={{color: COLOR.SUCCESS}}
              />
              <Clearfix width={8} />
              <Link to={this.props.slugBack ? this.props.slugBack : slug.BASE}>
                <Icon
                  icon={IconNames.DISABLE}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.DANGER}
                />
              </Link>
            </HeaderContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Tên cơ sở/dự án
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <FacilitySelect
              isDisabled={this.props.facility ? true : false}
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'facility',
                option: {
                  initialValue: this.props.facility
                    ? {
                        value: this.props.facility._id,
                        label: this.props.facility.FacilityNameFull,
                      }
                    : null,
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng chọn tên cơ sở/dự án',
                    },
                  ],
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('facility') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Địa chỉ phát sinh nước thải <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Địa chỉ phát sinh nước thải'
              {...getFieldProps('IncurredAddress', {
                initialValue: this.setInitialValue('IncurredAddress', ''),
                rules: [
                  {
                    required: true,
                    message: 'Vui lòng nhập địa chỉ phát sinh nước thải',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('IncurredAddress') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Điện thoại <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <NumberInput
              placeholder='Điện thoại'
              {...getFieldProps('Phone', {
                initialValue: this.setInitialValue('Phone', ''),
                rules: [
                  {
                    required: true,
                    message: 'Vui lòng nhập điện thoại',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('Phone') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Email</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Email'
              {...getFieldProps('Email', {
                initialValue: this.setInitialValue('Email', ''),
                rules: [
                  {
                    type: 'email',
                    message: 'định dạng Email không đúng',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('Email') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Fax</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Fax'
              {...getFieldProps('Fax', {
                initialValue: this.setInitialValue('Fax', ''),
              })}
            />
            <ErrorContainer>
              {(getFieldError('Fax') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Năm tính phí</LabelContainer>
          </Col>
          <Col xs={4}>
            <NumberInput
              placeholder='Năm tính phí'
              {...getFieldProps('YearOfCharge', {
                initialValue: this.setInitialValue('YearOfCharge', ''),
              })}
            />
            <ErrorContainer>
              {(getFieldError('YearOfCharge') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Quý tính phí <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <CustomDataSelect
              hideLabel
              data={QuaterOfChargeData}
              fieldForm={{
                form: this.props.form,
                name: 'QuaterOfCharge',
                option: {
                  initialValue: getDataForCustomSelect(
                    this.setInitialValue('QuaterOfCharge', null)
                  ),
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng chọn quý tính phí',
                    },
                  ],
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('QuaterOfCharge') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Thuộc đối tượng thu phí <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <CustomDataSelect
              hideLabel
              data={SubjectOfChargeData}
              fieldForm={{
                form: this.props.form,
                name: 'SubjectOfCharge',
                option: {
                  initialValue: getDataForCustomSelect(
                    this.setInitialValue('SubjectOfCharge', null)
                  ),
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng chọn thuộc đối tượng thu phí',
                    },
                  ],
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('SubjectOfCharge') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Thẩm quyền thu phí BVMT <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <CustomDataSelect
              hideLabel
              data={AuthorityBVMTData}
              fieldForm={{
                form: this.props.form,
                name: 'AuthorityBVMT',
                option: {
                  initialValue: getDataForCustomSelect(
                    this.setInitialValue('AuthorityBVMT', null)
                  ),
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng chọn thẩm quyền thu phí BVMT',
                    },
                  ],
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('AuthorityBVMT') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Công Nợ</LabelContainer>
          </Col>
          <Col xs={4}>
            <NumberInput
              placeholder='Công Nợ'
              {...getFieldProps('Indebtedness', {
                initialValue: this.setInitialValue('Indebtedness', null),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Tình trạng nộp phí <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <CustomDataSelect
              hideLabel
              data={PaymentStatusData}
              fieldForm={{
                form: this.props.form,
                name: 'PaymentStatus',
                option: {
                  initialValue: getDataForCustomSelect(
                    this.setInitialValue('PaymentStatus', null)
                  ),
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng chọn Tình trạng nộp phí',
                    },
                  ],
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('PaymentStatus') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        {isPaymentStatus && this.renderLogic()}
        {/* <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Nhu cầu sử dụng nước trung bình (m3/ngày)
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <NumberInput
              placeholder="Nhu cầu sử dụng nước trung bình"
              {...getFieldProps('AverageWaterDemand', {
                initialValue: this.setInitialValue('AverageWaterDemand', null)
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Lưu lượng nước thải phát sinh trung bình (m3/ngày)
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <NumberInput
              placeholder="Lưu lượng nước thải phát sinh trung bình"
              {...getFieldProps('AverageWasteWater', {
                initialValue: this.setInitialValue('AverageWasteWater', null)
              })}
            />
          </Col>
        </Row>

        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Lượng nước thải phát sinh theo hồ sơ môi trường (m3/ngày)
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <NumberInput
              placeholder="Lượng nước thải phát sinh theo hồ sơ môi trường"
              {...getFieldProps('AverageWasteWaterEnviProfile', {
                initialValue: this.setInitialValue(
                  'AverageWasteWaterEnviProfile',
                  null
                )
              })}
            />
          </Col>
        </Row>

        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Lượng nước thải phát sinh theo thực tế (m3/ngày)
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <NumberInput
              placeholder="Lượng nước thải phát sinh theo thực tế"
              {...getFieldProps('AverageWasteWaterActual', {
                initialValue: this.setInitialValue(
                  'AverageWasteWaterActual',
                  null
                )
              })}
            />
          </Col>
        </Row>

        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Tổng lượng nước thải phát sinh trong quý (m3/ngày)
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <NumberInput
              placeholder="Tổng lượng nước thải phát sinh trong quý"
              {...getFieldProps('TotalWasteWaterOfQuarter', {
                initialValue: this.setInitialValue(
                  'TotalWasteWaterOfQuarter',
                  null
                )
              })}
            />
          </Col>
        </Row>

        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Hàm lượng nước thải</LabelContainer>
          </Col>
          <Col xs={4}>
            <Table
              numRows={6}
              defaultRowHeight={40}
              defaultColumnWidth={200}
              enableGhostCells={true}
              selectionModes={SelectionModes.NONE}
              enableRowResizing={false}
            >
              <Column
                name="Chỉ tiêu"
                cellRenderer={rowIndex => {
                  return (
                    <Cell
                      style={{
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      {this.setInitialValue(
                        `WastewaterContent.${rowIndex}.name`,
                        WastewaterContentData[rowIndex]
                      )}
                    </Cell>
                  );
                }}
              />
              <Column
                name="Hàm lượng"
                cellRenderer={rowIndex => {
                  return (
                    <Cell>
                      <NumberInput
                        {...getFieldProps(`WastewaterContent.${rowIndex}`, {
                          initialValue: this.setInitialValue(
                            `WastewaterContent.${rowIndex}`,
                            {
                              name: WastewaterContentData[rowIndex]
                            }
                          ),
                          getValueProps: obj => {
                            return obj
                          },
                          getValueFromEvent: value => {
                            return {
                              name: WastewaterContentData[rowIndex],
                              value
                            };
                          }
                        })}
                      />
                    </Cell>
                  );
                }}
              />
            </Table>
          </Col>
        </Row>

        <Clearfix height={8} /> */}
      </div>
    );
  }
}

export default createForm()(FacilityEnviProtectFeeForm);



// WEBPACK FOOTER //
// ./src/containers/FacilityeEnviProtectFeeContainer/FacilityEnviProtectFeeForm/index.js